module.exports = __webpack_public_path__ + "static/media/Icon_Incoming_Tows_Gray.1cf6339c.svg";